import React from 'react'

import { Box, Typography } from '@material-ui/core'

import logoDponetWhite from 'images/dponet-logo-white.svg'
import { ReactComponent as HexagonosIcon } from 'images/hexagonos.svg'
import TrainingJourneyProvider from 'providers/TrainingJourneyProvider'
import useAuthTraining from 'hooks/useAuthTraining'
import useTrainingPortalTheme from 'hooks/useTrainingPortalTheme'
import useStyles from './styles'

const TrainingJourneyLayout = ({ children }) => {
  const classes = useStyles()
  const { company, loaded } = useAuthTraining()
  const { clientPortalTheme } = useTrainingPortalTheme()

  const logoUrl = clientPortalTheme?.logo || logoDponetWhite

  if (!loaded) return null

  return (
    <TrainingJourneyProvider>
      <Box component="main" className={classes.root}>
        <Box className={classes.leftPanel}>
          <HexagonosIcon className={classes.hexTop} />
          <img src={logoUrl} alt="Logo" className={classes.logo} />
          <Typography variant="body1" className={classes.welcomeText}>
            Bem-vindo ao portal de Treinamento da Empresa{' '}
            <strong>{company?.name}</strong>. Para começar, precisamos que você
            se identifique, basta informar seu nome e e-mail para prosseguir.
          </Typography>
        </Box>

        <Box className={classes.rightPanel}>
          <Box className={classes.card}>{children}</Box>
          <HexagonosIcon className={classes.hexBottom} />
        </Box>
      </Box>
    </TrainingJourneyProvider>
  )
}

export default TrainingJourneyLayout
